export const UkrainianEvacueeEmergencyFinancialSupports = 'UEEFS';
export const IncomeSupports = 'IS';
export const CEIS = 'CEIS';

export const IESProgramNames = {
  IncomeSupports,
  CEIS,
  UkrainianEvacueeEmergencyFinancialSupports,
};
